import { render } from "./ErrorPage.vue?vue&type=template&id=4c4bb4a0"
import script from "./ErrorPage.vue?vue&type=script&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&lang=ts"
script.render = render

export default script